import React from 'react';
import { Sun, Moon, CalendarBlank, CheckCircle, Clock, FileText } from 'phosphor-react';
import { ProgressLog } from '../../types/entities';
import { formatDate, formatDuration } from '../../use/useRoutineProgress';

interface RoutineLogCardProps {
  log: ProgressLog;
  onClick: () => void;
}

export default function RoutineLogCard({ log, onClick }: RoutineLogCardProps) {
  const isMorning = log.period === 'MORNING';
  const stepCount = log.stepLogs?.length ?? 0;
  const duration = formatDuration(log.totalDurationSeconds);

  return (
    <button
      onClick={onClick}
      className="bg-white dark:bg-gray-800 rounded-2xl shadow-soft dark:shadow-none dark:border dark:border-gray-700 p-4 text-left hover:shadow-soft-md hover:-translate-y-0.5 active:scale-[0.97] transition-[transform,box-shadow] duration-200 ease-soft"
    >
      <div className="flex items-start gap-3">
        <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center
          ${isMorning ? 'bg-blush-100 dark:bg-blush-900/30' : 'bg-lavender-100 dark:bg-lavender-900/30'}`}
        >
          {isMorning
            ? <Sun className="w-5 h-5 text-blush-500" />
            : <Moon className="w-5 h-5 text-lavender-500" />
          }
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-sm font-bold truncate ${isMorning ? 'text-blush-600 dark:text-blush-400' : 'text-lavender-600 dark:text-lavender-400'}`}>
            Rotina da {isMorning ? 'Manhã' : 'Noite'}
          </p>
          <div className="flex items-center gap-1.5 mt-0.5">
            <CalendarBlank className="w-3 h-3 text-nude-400 dark:text-gray-500" />
            <span className="text-xs text-nude-400 dark:text-gray-400">{formatDate(log.logDate)}</span>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4 mt-3 pt-3 border-t border-nude-50 dark:border-gray-700">
        <div className="flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-300 font-medium">
          <CheckCircle className="w-3.5 h-3.5 text-sage-500" />
          {stepCount} etapa{stepCount !== 1 ? 's' : ''}
        </div>
        {duration && (
          <div className="flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-300 font-medium">
            <Clock className="w-3.5 h-3.5 text-lavender-400" />
            {duration}
          </div>
        )}
        {log.notes && (
          <div className="flex items-center gap-1.5 text-xs text-nude-400 dark:text-gray-500 flex-1 min-w-0">
            <FileText className="w-3 h-3 flex-shrink-0" />
            <span className="truncate">{log.notes}</span>
          </div>
        )}
      </div>
    </button>
  );
}
